import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Cookies from 'js-cookie';
import { initReactI18next } from 'react-i18next';
import enCommon from './en/common.json';
import enTitles from './en/titles.json';
import rsCommon from './rs/common.json';
import rsTitles from './rs/titles.json';

const languageDetector = new LanguageDetector();
languageDetector.addDetector({
  name: 'cookie',
  lookup() {
    return Cookies.get('lang');
  },
  cacheUserLanguage(lng) {
    Cookies.set('lang', lng);
  },
});

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    lng: 'rs',
    fallbackLng: 'en',
    debug: false,
    defaultNS: 'common',
    ns: ['common', 'titles'],
    fallbackNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        common: enCommon,
        titles: enTitles,
      },
      rs: {
        common: rsCommon,
        titles: rsTitles,
      },
    },
  })
  .then(() => {
    console.info('i18n initialized');
  })
  .catch((error) => {
    console.error('i18n initialization error:', error);
  });

export default i18n;
